import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, workTypesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, workTypesActions);

export default slice.reducer;
